var App = App || {};

App.BioContactBand = (function ($) {
    "use strict";

    var $BioViewMore = $(".widget-bios"),
        $BioContactBand = $(".bio-contact-band")

    function Init() {
        const confirm = $BioViewMore.find(".item-bio-card a");

        if ($BioViewMore) {
            confirm.on("click", function () {
                var BioContactBandId = $(this).closest(".item-bio-card").data("bioid");

                App.Cookies.setItem("BioContactBandID", BioContactBandId, null, "/", null, "true");
                App.Cookies.setItem("BioContactBandDismissed-" + BioContactBandId, "false", null, "/", null, "true");
                updateHeaderSpace();
            });
        }


        $BioContactBand.on('click', '.bio-contact-band__dismiss', function () {
            dismissBioContactBand();
        });


        setTimeout(updateHeaderSpace, 500);

        if ($(".bio-contact-band").length > 0) {
            $(window).on("resize", updateHeaderSpace);
        }
    }

    function dismissBioContactBand() {
        var BioContactBandId = $(this).closest(".item-bio-card").data("bioid");

        $BioContactBand.slideUp(300);
        App.Cookies.setItem("BioContactBandDismissed-" + BioContactBandId, "true", null, "/", null, "true");
        $BioContactBand.css("max-height", "0px");
        updateHeaderSpace();
    }

    // change the height of the header spacer to fit one or more alerts
    function updateHeaderSpace() {
        var headerHeight = $(".headernav").height();
        $(".header-spacer").height(headerHeight);
    }

    function BioContactBandDismissed(BioContactBandId) {
        return App.Cookies.getItem("BioContactBandDismissed-" + BioContactBandId) === "true" ? true : false;
    }

    return {
        Init: Init
    };
})(jQuery);

$(function () {
    App.BioContactBand.Init();
});